import { Box, List, Switch, Text } from "@chakra-ui/react";
import { useState } from "react";
import {
  Globe,
  Smartphone,
  CreditCard,
  Building,
  Zap,
  Banknote,
} from "lucide-react";
import type {
  PaymentMethodMetrics,
  PaymentSourceMetrics,
} from "../../../../types/types";
import ListItemStatCard from "./ListItemStatCard";

type Props = {
  total: string | number;
  paymentMethods: PaymentMethodMetrics;
  source: PaymentSourceMetrics;
};

const SwitchStatCard = ({
  total,
  source,
  paymentMethods,
}: Props): JSX.Element => {
  const [isChecked, setIsChecked] = useState(false);

  const handleToggle = (details: { checked: boolean }) => {
    setIsChecked(details.checked);
  };

  return (
    <Box height="100%" gap="1.5rem">
      <Box display="flex" flexDirection="column" gap="1.5rem">
        <Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            mb={2}
          >
            <Box>
              <Text fontSize="1.1rem" fontWeight="600" color="#1A202C">
                {isChecked ? "Canales de Pago" : "Métodos de Pago"}
              </Text>
              <Text color="#858D9D" fontSize="0.85rem" fontWeight="500">
                Total pagado este mes
              </Text>
            </Box>
            <Switch.Root
              checked={isChecked}
              onCheckedChange={handleToggle}
              colorScheme="purple"
            >
              <Switch.HiddenInput />
              <Switch.Control>
                <Switch.Thumb />
              </Switch.Control>
            </Switch.Root>
          </Box>
        </Box>
        <Text fontSize="2rem" fontWeight="700" color="#1A202C">
          {total}
        </Text>
      </Box>
      <Box mt={6}>
        <List.Root gap={4} width="100%">
          {!isChecked && (
            <>
              <ListItemStatCard
                lable="PSE"
                value={paymentMethods.pse}
                share={paymentMethods.pse_pct}
                icon={Building}
                color="#3182CE"
                key="PSE"
              />
              <ListItemStatCard
                lable="Bancolombia"
                value={paymentMethods?.bancolombiabutton}
                share={paymentMethods?.bancolombiabutton_pct}
                icon={Building}
                color="#D69E2E"
                key="Bancolombia"
              />
              <ListItemStatCard
                lable="Nequi"
                value={paymentMethods?.nequibutton}
                share={paymentMethods?.nequibutton_pct}
                icon={Smartphone}
                color="#D53F8C"
                key="Nequi"
              />
              <ListItemStatCard
                lable="Tarjetas"
                value={paymentMethods?.card}
                share={paymentMethods?.card_pct}
                icon={CreditCard}
                color="#A0AEC0"
                key="Tarjetas"
              />
              <ListItemStatCard
                lable="Bre-B"
                value={paymentMethods?.breb}
                share={paymentMethods?.breb_pct}
                icon={Zap}
                color="#10A6B5"
                key="Bre-B"
              />
              <ListItemStatCard
                lable="Efectivo"
                value={paymentMethods?.cash}
                share={paymentMethods?.cash_pct}
                icon={Banknote}
                color="#3CB18B"
                key="Efectivo"
              />
            </>
          )}
          {isChecked && (
            <>
              <ListItemStatCard
                lable="Portal"
                value={source?.portal}
                share={source?.portal_pct}
                icon={Globe}
                color="#5B52ED" // Purple from mockup
                key="Portal"
              />
              <ListItemStatCard
                lable="WhatsApp"
                value={source?.whatsapp}
                share={source?.whatsapp_pct}
                icon={Smartphone}
                color="#38C67B" // Green from mockup
                key="WhatsApp"
              />
            </>
          )}
        </List.Root>
      </Box>
    </Box>
  );
};

export default SwitchStatCard;
